import Vue from 'vue'
import Router from 'vue-router'
import config from '@/config'
Vue.use(Router)
const router = new Router({
  routes: config.routers
})

export default router
